module.exports = __webpack_public_path__ + "static/kutsinta-dec4a5f87512274eafa2bada20511f18.jpg";